export const LOAD_CHATSCRIPT_SUCCESS = 'LOAD_CHATSCRIPT_SUCCESS';